<template>
    <div id="">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
        <!--<mt-tabbar v-model="selected">-->
            <!--<mt-tab-item id="index">-->
                <!--<img slot="icon" src="../assets/home.png" alt="">-->
                <!--主页-->
            <!--</mt-tab-item>-->
            <!--<mt-tab-item id="byBus">-->
                <!--<img slot="icon" src="../assets/qrd.png" alt="">-->
                <!--乘车-->
            <!--</mt-tab-item>-->
            <!--<mt-tab-item id="my">-->
                <!--<img slot="icon" src="../assets/my.png" alt="">-->
                <!--我的-->
            <!--</mt-tab-item>-->
        <!--</mt-tabbar>-->
    </div>
</template>

<script type="es6">
  import { MessageBox,Indicator} from 'mint-ui';
  export default {
    name: 'app',
    data () {
      return {
          selected:"",
      }
    },
      watch: {
          selected(val) {
              this.toPath(val)
          }
      },
    mounted () {


    },
    methods:{
        toPath(path){
            this.$router.push(path)
        },

    }
  }
</script>

<style scoped>
    .p_img{
        width: 150px;
        height: 110px;
        margin: 0 auto;
        padding-top: 100px;
    }
    .p_img img{
        width: 150px;
        height: 110px;
    }
    .btn{
        padding: 0 10px;
        margin-top: 30px;
        margin-bottom: 30px;
    }
    .p_text{
        padding: 30px;
        font-size:17px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:25px;
    }
    .btn button{
        width: 100%;
    }
#contain{
    background: #fff;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue